import firebase from "firebase";
import {deserialize} from "serializr";
import {UserModel} from "@/modules/mprofiles/models/UserModel";
import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";
import {SnapshotModel} from "@/modules/mprofiles/models/SnapshotModel";
import {FolderModel} from "@/modules/mprofiles/models/FolderModel";

export default {
    namespaced: true,
    state: {
        mUser: {},
        mSnapshots: [],
        mFolders: [],
    },
    getters: {
        getUser: state => {
            return state.mUser;
        },
        getFolders: state => {
            return state.mFolders;
        },
        getSnapshots: state => {
            return state.mSnapshots;
        },
    },
    mutations: {
        setUser(state, values) {
            state.mUser = values;
        },
        setSnapshots(state, values) {
            state.mSnapshots = values;
        },
        setFolders(state, values) {
            state.mFolders = values;
        },
    },
    actions: {
        init() {
            console.info('users-backend initialized.');
        },
        fetchUser({commit}, uid) {
            console.log("uid:", uid)
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getUserData/' + uid, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            //console.log(JSON.parse(data))
                                            commit("setUser", deserialize(UserModel, JSON.parse(data)));
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fetchUserSave({/*commit*/}, uid) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getUserSave/' + uid, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            return data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        createUserSnapshot({/*commit*/}, data) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'createUserSnapshot', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            return data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                    //return UsersBackendUtils.fetchUsersSnapshots();
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setAudience({/*commit*/}, {uid, aud}) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify({userId: uid, aud: aud})
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setUserAudience', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return UsersBackendUtils.fetchUser(uid)
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fetchUsersSnapshots({commit}) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getSnapDetails', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            //console.log(data)
                                            let values = JSON.parse(data).map(v => deserialize(SnapshotModel, v));
                                            commit("setSnapshots", values);
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        deleteUserSnapshots({/*commit*/}, ids) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                            body:JSON.stringify(ids)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'removeSnapshots', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return UsersBackendUtils.fetchUsersSnapshots();
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        updateSnapshotInfo({/*commit*/}, data) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'updateSnapshotInfo', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return UsersBackendUtils.fetchUsersSnapshots();
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        fetchSnapFolders({commit}) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getSnapFolders', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return data.text()
                                        .then((data) => {
                                            let parcedData = JSON.parse(data);
                                            if (parcedData != null) {
                                                let values = parcedData.map(v => deserialize(FolderModel, v));
                                                commit("setFolders", values);
                                            } else {
                                                commit("setFolders", []);
                                            }
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        createSnapFolder({/*commit*/}, data) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'createSnapFolder', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return UsersBackendUtils.fetchSnapFolders();
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        moveSnapshotToFolder({/*commit*/}, data) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'moveSnapshotToFolder', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return UsersBackendUtils.fetchSnapFolders()
                                        .then(() => {
                                            UsersBackendUtils.fetchUsersSnapshots()
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        removeSnapFolder({/*commit*/}, fid) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "DELETE",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'removeSnapFolder/' + fid, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return UsersBackendUtils.fetchSnapFolders();
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setSnapshotFolderName({/*commit*/}, data) {
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: {"Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(data)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setSnapshotFolderName', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data) => {
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    return UsersBackendUtils.fetchSnapFolders();
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}

